import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

const application = Application.start();
application.debug = false;
window.Stimulus = application;

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));

export { application };
